import { EXPERTISE } from "../data/content";
import { Reveal } from "./Reveal";

const IMG =
  "https://images.unsplash.com/photo-1512102438733-bfa4ed29aef7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob3NwaXRhbCUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzgwMDE5NTY3fDA&ixlib=rb-4.1.0&q=85";

export const Expertise = () => {
  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <Reveal className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#0A192F]/40" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
                Healthcare Innovation Expertise
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F]">
              Where clinical insight
              <br />
              meets capital and code.
            </h2>
            <div className="mt-10 overflow-hidden">
              <img
                src={IMG}
                alt="Healthcare innovation environment"
                className="w-full h-72 object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <ol className="divide-y divide-[#0A192F]/10">
              {EXPERTISE.map((e, i) => (
                <Reveal key={e.title} delay={i * 90} className="py-8 lg:py-10 first:pt-0">
                  <div className="flex items-baseline gap-6">
                    <span className="font-serif text-2xl text-[#0A192F]/30 ticker">
                      0{i + 1}
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl lg:text-3xl text-[#0A192F]">
                        {e.title}
                      </h3>
                      <p className="mt-3 text-[#475569] leading-relaxed max-w-2xl">
                        {e.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};
